import { useEffect, useState, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AddToCartButton({
  loading,
  handleAddToCart,
  quantity,
  toggleWishlist,
  selectedSize,
}) {
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [isSticky, setIsSticky] = useState(true);
  const buttonRef = useRef(null);
  const productInfoRef = useRef(null);

  // Sync wishlist state
  useEffect(() => {
    setIsWishlisted(selectedSize?.is_wishlisted === 1);
  }, [selectedSize]);

  // Mobile scroll logic
  useEffect(() => {
  const productInfo = document.querySelector(".product-info");
  if (!productInfo || !buttonRef.current) return;

  let ticking = false;
  let lastSticky = null;

  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const productRect = productInfo.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const shouldBeSticky = productRect.bottom > viewportHeight;

        if (lastSticky !== shouldBeSticky) {
          lastSticky = shouldBeSticky;
          setIsSticky(shouldBeSticky);
        }

        ticking = false;
      });

      ticking = true;
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const nextState = !isWishlisted;
    setIsWishlisted(nextState);
    toggleWishlist(e, selectedSize, nextState);
  };

  return (
    <div
      ref={buttonRef}
      className={`add-cart-sticky-wrapper ${isSticky ? "sticky-bottom" : ""}`}
    >
      <div className="add-cart-section">
        {loading ? (
          <>
            <Skeleton height={45} width={380} borderRadius={8} />
            <Skeleton width={36} height={36} style={{ marginLeft: 12 }} />
          </>
        ) : (
          <>
            <button
              type="button"
              className="add-to-cart-btn_qucick"
              onClick={handleAddToCart}
              disabled={quantity === 0}
            >
              {quantity === 0 ? "Out of stock" : "ADD TO CART"}
            </button>

            <button
              type="button"
              className="wst_box pointer-crusser mt-0"
              onClick={handleWishlistClick}
              aria-label="wishlist"
              style={{ paddingTop: "5px" }}
            >
              <i
                className={`bi ${
                  isWishlisted ? "bi-heart-fill text-danger" : "bi-heart"
                }`}
              />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
export default AddToCartButton;